import { Box, Checkbox, Tooltip, Typography } from '@mui/material';
import { TEST_IDS } from 'shared';
import { AutocompleteField } from 'components/form';
import { useFormContext, useWatch } from 'react-hook-form';
import { CcEmailOption, ContactForm, EmailRecipientsProps, FinanceProgramFormValues } from '../../../../../types';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import InfoIcon from '@mui/icons-material/Info';

export const EmailRecipients = ({ ccEmailOptions }: EmailRecipientsProps) => {
  const { control } = useFormContext<FinanceProgramFormValues>();

  const contact = useWatch({ control, name: 'contact' });

  const getContactLabel = (contact: CcEmailOption | ContactForm, includeEmail = false) => {
    const label = `${contact.fullName}${contact.title ? `, ${contact.title}` : ``}`;
    return includeEmail ? `${label} - ${contact.email}` : label;
  };

  return (
    <>
      <Box>
        <Typography variant="subtitle2" component="span">
          Send Email To:{' '}
        </Typography>
        <Typography component="span">{getContactLabel(contact, true)} </Typography>
        <Tooltip placement="top" title="To Adjust, make change in Customer Card above">
          <InfoIcon color="primary" fontSize="small" sx={{ verticalAlign: 'sub' }} />
        </Tooltip>
      </Box>

      <AutocompleteField<any, true, FinanceProgramFormValues>
        control={control}
        name="ccEmail"
        multiple
        disableCloseOnSelect
        limitTags={3}
        dataTestId={TEST_IDS.desking.sendVia.ccEmail}
        options={ccEmailOptions!.sort((a, b) => -b.group.localeCompare(a.group))}
        groupBy={option => option.group}
        getOptionLabel={option => getContactLabel(option)}
        isOptionEqualToValue={(option, value) => value && option.email === value?.email}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {getContactLabel(option, true)}
            </li>
          );
        }}
        textFieldProps={{ label: 'CC Email to' }}
        sx={{ width: '50%' }}
      />
    </>
  );
};
